export type DeletionCapability = { id: string; token: string };
function valid(value: unknown): value is DeletionCapability {
  const item = value as DeletionCapability | null;
  return !!item && typeof item.id === "string" && typeof item.token === "string" && /^[a-f0-9]{64}$/.test(item.id) && /^[a-f0-9]{64}$/.test(item.token);
}
/** Keep the capability in this history entry, never in URLs or shared localStorage. */
export function restoreDeletionCapability(): DeletionCapability | null {
  const hash = window.location.hash;
  const saved = window.history.state?.accountDeletion;
  const parts = hash.slice(1).split(".");
  const candidate = hash ? (parts.length === 2 ? { id: parts[0], token: parts[1] } : null) : saved?.capability;
  const expiresAt = hash ? Date.now() + 86_400_000 : saved?.expiresAt;
  const capability = valid(candidate) && typeof expiresAt === "number" && expiresAt > Date.now() ? candidate : null;
  window.history.replaceState(capability ? { accountDeletion: { capability, expiresAt } } : null, "", window.location.pathname);
  return capability;
}
